/** UI-only filter sentinels for org/style scoped prompt lists. */
export const PromptScopeFilter = Object.freeze({
  Any: "__any__",
  None: "__none__",
});

export const ANY_ORG_FILTER_OPTION = {
  value: PromptScopeFilter.Any,
  label: "All organizations",
};

export const NO_ORG_FILTER_OPTION = {
  value: PromptScopeFilter.None,
  label: "No organization (global)",
};

export const ANY_STYLE_FILTER_OPTION = {
  value: PromptScopeFilter.Any,
  label: "All styles",
};

export const NO_STYLE_FILTER_OPTION = {
  value: PromptScopeFilter.None,
  label: "Org default (no style)",
};

export function isPromptScopeAny(value) {
  return value === PromptScopeFilter.Any;
}

export function isPromptScopeNone(value) {
  return value === PromptScopeFilter.None;
}

export function isSpecificPromptScopeId(value) {
  return (
    value !== undefined &&
    value !== null &&
    !isPromptScopeAny(value) &&
    !isPromptScopeNone(value)
  );
}

/** Maps a UI filter value to an API query param (undefined = omit). */
export function toPromptScopeQueryParam(value) {
  if (value === undefined || isPromptScopeAny(value)) return undefined;
  if (isPromptScopeNone(value)) return "";
  return value;
}
